import React from "react";
import "./button.css";

interface Props {
  text: string;
  variant: string;
  onclick: () => void;
}

const Button: React.FC<Props> = ({ text, variant, onclick }) => (
  <React.Fragment>
    <button className={`${variant} font-sora`} onClick={onclick}>
      {text}
    </button>
  </React.Fragment>
);
export default Button;
